<template>
  <AtomsGlobalDialog :is-open="dialog?.isOpen" :is-message-container="dialog?.isMessageContainer" @close="close" class="w-[700px]">
    <div class="px-4 py-6 tablet:px-6 desktop:px-10">

      <!-- heading -->

      <strong class="block mb-8 pb-8 uppercase font-bold text-2xl border-b border-neutral-200">{{ $t('Kdy obdržím poukaz?') }}</strong>

      <!-- overcount -->

      <div>{{ $t('Jakmile obdržíme platbu, poukaz Vám pošleme obratem do e-mailu. U bankovního převodu je to ve chvíli, kdy se nám ze systému sehrají platby, u platby online kartou je to podobné. V obou případech to je vždy nejpozději následující pracovní den.') }}</div>

    </div>
  </AtomsGlobalDialog>
</template>
<script setup>

const close = () => useDialog().close();

const dialog = computed(() => useDialog().get('electronicDistributionInfo'));

</script>